module.exports = __webpack_public_path__ + "static/media/icon512.56f5df56.png";